const PLAN_DISPLAY_NAMES = {
  free: 'Pickup',
  starter: 'League',
  pro: 'Commissioner',
};

function getPlanDisplayName(plan) {
  return PLAN_DISPLAY_NAMES[plan] || plan;
}

export { PLAN_DISPLAY_NAMES, getPlanDisplayName };
